/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

/* ===== Epik : ajout / retrait direct au panier depuis la grille produit =====
   Le "+" ajoute 1 unité au panier (Ajax /cart/add.js), le "-" en retire 1
   (Ajax /cart/change.js). Pas de bouton "ajouter au panier" séparé : chaque
   clic agit immédiatement sur le panier, comme sur les sites de courses en ligne.
   Délégation d'événement sur document : fonctionne même après un rechargement
   Ajax de la grille (filtres, tri, pagination) sans réinitialisation. */

function EpikRenderQty(row, qty) {
  var valueEl = row.querySelector('[data-qty-value]');
  row.setAttribute('data-qty', qty);
  if (qty > 0) {
    row.classList.add('has-qty');
    if (valueEl) {
      valueEl.textContent = qty;
    }
  } else {
    row.classList.remove('has-qty');
    if (valueEl) {
      valueEl.textContent = '';
    }
  }
}

function EpikSyncCartQuantities() {
  if (!window.theme || !theme.routes_cart_url) {
    return;
  }
  fetch(theme.routes_cart_url + '.js', {headers: {'Accept': 'application/json'}})
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var qtyByVariant = {};
      (cart.items || []).forEach(function (item) {
        qtyByVariant[item.variant_id] = (qtyByVariant[item.variant_id] || 0) + item.quantity;
      });
      document.querySelectorAll('[data-quick-add]').forEach(function (row) {
        var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
        EpikRenderQty(row, qtyByVariant[variantId] || 0);
      });
    })
    .catch(function (err) {
      console.error('!: ' + err);
    });
}

function EpikCartAdjust(row, delta) {
  if (row.classList.contains('loading') || row.getAttribute('data-unavailable') === 'true') {
    return;
  }
  var variantId = row.getAttribute('data-variant-id');
  var currentQty = parseInt(row.getAttribute('data-qty'), 10) || 0;
  var qtyMax = parseInt(row.getAttribute('data-qty-max'), 10);
  var newQty = currentQty + delta;
  if (newQty < 0) {
    newQty = 0;
  }
  if (delta > 0 && !isNaN(qtyMax) && qtyMax > 0 && newQty > qtyMax) {
    return;
  }
  if (delta > 0 && currentQty === newQty) {
    return;
  }
  row.classList.add('loading');
  var request;
  if (currentQty === 0 && delta > 0) {
    request = fetch(theme.routes_cart_add_url + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: variantId, quantity: 1})
    });
  } else {
    request = fetch(theme.routes_cart_change_url + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: variantId, quantity: newQty})
    });
  }
  request.then(function (r) { return r.json(); })
    .then(function () {
      row.classList.remove('loading');
      EpikRenderQty(row, newQty);
      if (typeof CartDrop === 'function') {
        /* Sur mobile, on ne montre pas l'aperçu du panier automatiquement après
           un ajout/retrait : on passe x=true pour que CartDrop mette juste à
           jour le contenu/compteur en silence. L'aperçu ne s'ouvre alors que si
           le client clique lui-même sur l'icône panier. Sur desktop, l'aperçu
           reste visible en continu (colonne à droite), donc le comportement
           habituel est conservé. */
        var isMobile = window.theme && theme.width <= theme.breakpoint_margin;
        CartDrop(isMobile ? true : false);
      }
      document.dispatchEvent(new CustomEvent('cartItems', {bubbles: true}));
    })
    .catch(function (err) {
      row.classList.remove('loading');
      console.error('!: ' + err);
    });
}

document.addEventListener('click', function (e) {
  var row = e.target.closest('[data-quick-add]');
  if (!row) return;
  if (e.target.closest('.mini-qty-plus')) {
    EpikCartAdjust(row, 1);
  } else if (e.target.closest('.mini-qty-minus')) {
    EpikCartAdjust(row, -1);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  EpikSyncCartQuantities();
  var target = document.getElementById('collection-products');
  if (target && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      EpikSyncCartQuantities();
    });
    observer.observe(target, {childList: true, subtree: false});
  }
});

document.addEventListener('cartItems', EpikSyncCartQuantities);

/* ===== Epik : fiche produit — suivre le changement de variante =====
   Le thème place la nouvelle variante sélectionnée dans l'input caché [name="id"]
   du formulaire produit avant de déclencher "_changeVariant". On récupère cette
   valeur pour que le "+/-" agisse toujours sur la bonne variante, et on grise le
   contrôle si la variante choisie n'est plus disponible. */
document.addEventListener('_changeVariant', function () {
  document.querySelectorAll('.quick-add-row.quick-add-row--large').forEach(function (row) {
    var form = row.closest('form');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    row.setAttribute('data-variant-id', idInput.value);
  });
  EpikSyncCartQuantities();
});

/* ===== Epik : aperçu du panier — quantité des articles déjà dans le panier =====
   Le "+/-" agit ici directement sur la ligne de panier existante (Ajax
   /cart/change.js, identifiée par sa clé unique), sans passer par
   /cart/add.js. Après chaque clic, on redemande le contenu de l'aperçu au
   serveur (CartDrop) pour que la liste, les économies et le total restent
   toujours exacts. */
function EpikCartLineAdjust(row, delta) {
  if (row.classList.contains('loading') || !window.theme || !theme.routes_cart_change_url) {
    return;
  }
  var lineKey = row.getAttribute('data-line-key');
  var currentQty = parseInt(row.getAttribute('data-qty'), 10) || 0;
  var newQty = currentQty + delta;
  if (newQty < 0) {
    newQty = 0;
  }
  row.classList.add('loading');
  fetch(theme.routes_cart_change_url + '.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify({id: lineKey, quantity: newQty})
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (typeof CartDrop === 'function') {
        CartDrop(false);
      }
      document.dispatchEvent(new CustomEvent('cartItems', {bubbles: true}));
    })
    .catch(function (err) {
      row.classList.remove('loading');
      console.error('!: ' + err);
    });
}

document.addEventListener('click', function (e) {
  var row = e.target.closest('[data-cart-line]');
  if (!row) return;
  if (e.target.closest('.mini-qty-plus')) {
    EpikCartLineAdjust(row, 1);
  } else if (e.target.closest('.mini-qty-minus')) {
    EpikCartLineAdjust(row, -1);
  }
});

/* "Vider le panier" : vide le panier en Ajax puis rafraîchit l'aperçu, sans
   recharger la page. Le lien reste un vrai <a href="/cart/clear"> pour
   fonctionner même si JavaScript est désactivé. */
document.addEventListener('click', function (e) {
  var clearLink = e.target.closest('[data-cart-clear]');
  if (!clearLink || !window.theme || !theme.routes_cart_url) {
    return;
  }
  e.preventDefault();
  fetch(theme.routes_cart_url + '/clear.js', {
    method: 'POST',
    headers: {'Accept': 'application/json'}
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (typeof CartDrop === 'function') {
        CartDrop(false);
      }
      document.dispatchEvent(new CustomEvent('cartItems', {bubbles: true}));
    })
    .catch(function (err) {
      console.error('!: ' + err);
    });
});